export default __webpack_public_path__ + "static/media/jpg.3c3230c1.svg";